<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="title" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle">
            <div style="flex: 1; padding: 0 12px; margin-top: 15px;">
                <template v-if="mode === SCOUTING_TYPE.VIEWED">
                    <div>
                        <div v-for="each, i in viewedPlayers " :key="i + 'viewd_players'" style="display: flex; align-items: center; margin-bottom: 20px;">
                            <div style="display: flex; align-items: center; gap: 20px; flex: 1;">
                                <div style="font-weight: 700;">{{ each.rank }}</div>
                                <CommonProfileNew :memberInfo="each"></CommonProfileNew>
                            </div>
                            <div style="font-weight: 700; color: var(--color-main);">{{ each.visit_count }}회</div>
                        </div>
                    </div>
                </template>
                <template v-else-if="mode === SCOUTING_TYPE.INTERESTED">
                    <div v-for="each, i in interestedPlayers " :key="i + 'interested_players'" style="display: flex; align-items: center; margin-bottom: 24px;">
                        <div style="flex: 1;">
                            <CommonProfileNew :memberInfo="each"></CommonProfileNew>
                        </div>
                        <div @click="sendMessage(each)" style="width: 78px; height: 40px; border-radius: 12px; line-height: 40px; text-align: center; background-color: #f5f5f5; color: var(--color-main); font-size: 14px; font-weight: 700;">메시지</div>
                    </div>
                </template>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
const SCOUTING_TYPE = {
    // 우리 팀을 살펴본 선수들
    VIEWED: 'viewed',
    // 우리팀에 관심가진 선수들
    INTERESTED: 'interested'
}

import MercenaryHeader from '@/components/common/MercenaryHeader'
import CommonProfileNew from '@/components/common/CommonProfileNew';
import InfinityScroll from '@/components/common/InfinityScroll'

export default {
    name: 'ScoutingReportDetail',
    components: { MercenaryHeader, CommonProfileNew, InfinityScroll },
    props: {
        mode: {
            type: String,
            default: SCOUTING_TYPE.VIEWED
        },
        teamIdx: {
            type: [String, Number],
            default: -1
        }
    },
    computed: {
        title() {
            if (this.mode === SCOUTING_TYPE.VIEWED) {
                return '우리 팀을 살펴본 선수들'
            } else if (this.mode === SCOUTING_TYPE.INTERESTED) {
                return '우리 팀에 관심 가진 선수'
            } else {
                return ''
            }
        }
    },
    created() {
        this.getMyTeamViews()
    },
    data() {
        return {
            SCOUTING_TYPE: SCOUTING_TYPE,
            viewedPlayers: [],
            interestedPlayers: [],
            page: 1,
            isEnableNextPageHandle: true
        }
    },
    methods: {
        refresh() {
            this.page = 1
            this.viewedPlayers = []
            this.interestedPlayers = []
            this.getMyTeamViews()
        },
        handleNextPage() {
            this.page++
            this.getMyTeamViews()
        },
        setRanking() {
            const sorted = [...this.viewedPlayers].sort((a, b) => b.visit_count - a.visit_count);
            let prevCount = null;
            let prevRank = 0;
            let realRank = 0;

            sorted.forEach((item) => {
                realRank++; // 실제로 몇 번째인지 (1,2,3,4,5 ...)
            
                if (item.visit_count !== prevCount) {
                    // 새로운 visit_count면 그 순위가 등수
                    prevRank = realRank;
                    prevCount = item.visit_count;
                }
            
                // rank를 저장
                item.rank = prevRank;
            });
        },
        async getMyTeamViews() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.team_idx = this.teamIdx
            parameters.team_views_page = this.page
            parameters.interested_page = this.page
            parameters.is_get_team_views = this.mode === SCOUTING_TYPE.VIEWED ? true : false
            parameters.is_get_interested_players = this.mode === SCOUTING_TYPE.INTERESTED ? true : false

            const res = await this.$Axios.get('/api/coach/scouting/team_views', { params: parameters })
            const viewedPlayers = res.data.viewed_players
            const interestedPlayers = res.data.interested_players

            if (this.mode === SCOUTING_TYPE.VIEWED) {
                if (viewedPlayers.length > 0) {
                    this.isEnableNextPageHandle = true
                    this.viewedPlayers = [...this.viewedPlayers, ...viewedPlayers]
                    this.setRanking()
                }
            } else {
                if (interestedPlayers.length > 0) {
                    this.isEnableNextPageHandle = true
                    this.interestedPlayers = [...this.interestedPlayers, ...interestedPlayers]
                }
            }
        },
        sendMessage(memberInfo) {
            this.$Util.showDirectMessageSenderForm({ memberInfo: memberInfo, isDirectUser: true });
        },
    }
}
</script>